import { ApolloClient, InMemoryCache } from '@apollo/client'
import decorateLink from './LinkService'
import { DecoratedClientProps } from './index'

const cache = new InMemoryCache({
  possibleTypes: {
    Content: ['Video', 'Event'],
    MediaItem: ['Video', 'Event'],
  },
  typePolicies: {
    Home: {
      fields: {
        rows: {
          keyArgs: false,
          merge(existing = [], incoming = []) {
            return [...existing, ...incoming]
          },
        },
      },
    },
    Page: {
      fields: {
        rows: {
          keyArgs: false,
          merge(existing = [], incoming = []) {
            return [...existing, ...incoming]
          },
        },
      },
    },
  },
})

const decorateClient = (props: DecoratedClientProps) =>
  new ApolloClient({
    link: decorateLink(props),
    cache,
    name: `${process.env.REACT_APP_SITE_TITLE} Web OTT`,
    version: process.env.REACT_APP_VERSION,
  })

export default decorateClient
